<app-select-filter-v2
        [loading]="loading"
        [parentFormGroup]="parentFormGroup" [parentFormControlName]="parentFormControlName"
        [elements]="elements"
        (_onSingleSelectionChange)="singleSelectionChangeEvent.emit($event?.element)">
</app-select-filter-v2>
